const getPriorityStyle = (priority?: string) => {
  switch (priority) {
    case 'MEDIUM':
      return 'text-warning-base border-warning-base';
    case 'HIGH':
      return 'text-danger-base border-danger-base';
    default:
      return 'text-secondary-base border-secondary-base';
  }
};

export default getPriorityStyle;
